
const WordofWisdomeCard = () => {
  
// const qaData = [
//     { question: "What never goes out of style?", answer: "Kindness." },
//     { question: "What makes a person attractive?", answer: "Confidence and Genuineness." },
//     { question: "How can I get rid of anxiety?", answer: "Let go of expectations" },


//     { question: " How can I stop worrying?", answer: "By having faith that everything is happening for a reason." },
//     { question: "How must I serve God?", answer: "With gratitude and humility." },
//     { question: "What can I do to avoid envy?", answer: "Convert it into admiration." },
//     { question: "What is the importance of prayer?", answer: "It is food and water for the soul." },
//     { question: "What is more precious than gold?", answer: "True friendship." },
//     { question: "Who should I be cautious about?", answer: "Those who flatter you." },


//     { question: "Why am I not moving ahead in my spiritual life?", answer: "Procrastination" },
//     { question: "What will help me find time for devotional practice?", answer: "Accepting that peace and happiness are the byproducts of devotion." }
  




    


    
//   ];



    return (

        <>

            {/* <!--Sidebar Page Container--> */}
            <div className="sidebar-page-container">
                <div className="auto-container">
                    <div className="row clearfix">

                        {/* <!--Content Side / Blog Detail--> */}
                        <div className="content-side col-lg-12 col-md-12 col-sm-12">
                            <div className="post-details">
                                {/* <!--Blog Details--> */}
                                <div className="blog-details">


                                    <div className="lower-box">


                                        <div className="panel panel-primary">
                                            <div className="panel panel-heading">
                                                {/* <h4>Words of Wisdom - Question & Answer Session - #140   </h4> */}
                                                <h4>Words of Wisdom - An Ending Leads to a New Beginning </h4>

                                            </div>

                                            <div className="panel panel-body">
                                                <div className='row'>
                                                    <div className="col-md-12">

                                                        {/* <p> Children are fearless; they are always trying something new. Adults would do well to get into the spirit of a child and do something new. I have a few ideas. I dare you to try them! </p> */}
                                                        {/* <ul className="wordofwisdon_list">
                                                            <li> For the one who has never done it……. I dare you to walk in the rain without an umbrella.
                                                            </li>

                                                            <li> For the stoic male………I dare you to express your emotions and know that it’s okay to cry. </li>

                                                            <li>  For the female……..I dare you to contain your emotions at times and not allow your heart to rule your mind.</li>

                                                            <li> For the person who doesn’t cook…….I dare you to prepare a meal.</li>

                                                            <li> For the worrywart……..I dare you to stop worrying and start living.</li>

                                                            <li>  For the married person……….I dare you to look at your spouse’s point of view. </li>

                                                            <li>   For the highly organized person…..I dare you to do something spontaneous.</li>
                                                            <li> For the procrastinator…….I dare you to finish an important task today. </li>
                                                            <li> For the angry person………I dare you to decide that anger is a harmful emotion.</li>
                                                            <li> For the critical person……..I dare you replace your critical behavior with an understanding heart. </li>
                                                            <li> For the lazy person……..I dare you to discover the joy of working hard.</li>

                                                            <li> For the workaholic……..I dare you to relax and sit a while without doing anything.</li>
                                                            <li> For the teenager……….I dare you to communicate with your family.</li>
                                                            <li> For the seniors……..I dare you to ignore your age and think young.</li>

                                                            <li> For the juniors………I dare you to learn from the seniors in your family.</li>
                                                            <li> For the social media addict………I dare you to live one entire weekend without social media.</li>
                                                            <li> For the video game addict……..I dare you to play outside and discover the joys of Nature.</li>
                                                            <li> For everyone reading this………I dare you to have a wonderful weekend. </li>
                                                      
                                                      
                                                      
                                                      
                                                        </ul> */}
                                                      

                                                      <p>We hear and use the expression, “Everything good must come to an end one day.” We speak these words with a regretful sigh.
                                                         We lament the passing of something good that we had in life. It’s true that everything good comes to an end one day. 
                                                         It’s also true that everything bad comes to an end one day. If a marriage comes to an end, the abuse, 
                                                         fights and arguments between two people also come to an end. 
                                                         If a popular boys’ band breaks up, it is the beginning of a solo career for band members. 
                                                        When high school education comes to an end, college life begins.
                                                    </p>

                                                    <p> Rather than grieving the end of something we hold dear, let’s celebrate the beginning of something new. 
                                                        When spring comes to an end, summertime arrives. When summer comes to an end, the autumn season arrives.
                                                         When autumn comes to an end, winter begins. 
                                                        Every season has its own beauty worth noticing and appreciating.
                                                    </p>

                                                    <p> When life as we knew it comes to an end, challenges begin. It’s a waste of time brooding over the changes and wishing everything to have remained the same.
                                                         We should live constructively by embracing challenges and adapting ourselves to meet these challenges.
                                                         We should also keep in mind that challenges will also come to an end one day.
                                                     </p>

                                                     <p> We reminisce about the ‘good old days.’ We mourn the days that will never return. While mourning the loss of our past, 
                                                        we overlook the present which is not bad at all. The days of the past had to end for the present to arrive. 
                                                        Appreciate the new beginnings rather than holding on to the past.
                                                    </p>

                                                    <p> The caterpillar must shed its former self for the butterfly to arrive. Every ending leads to a new beginning.</p>

                                                    {/* <div>
      {qaData.map((item, index) => (
        <div key={index} >
          <h5> Q: {item.question}</h5>
          <p style={{fontSize: '20px', borderBottom:"1px solid #ccc" }}> A: {item.answer}</p>
        </div>
      ))}
    </div> */}
                                                     

                                                        <hr />
                                                        <p> Yours,</p>
                                                        <p> Didi Ji</p>
                                                        <p className="text-center"> Note: You may direct your spiritual questions to me
                                                            directly at</p>
                                                        <p className="text-center"> s_didi@radhamadhavsociety.org</p>


                                                    </div>

                                                </div>

                                            </div>


                                        </div>




                                    </div>






                                </div>





                            </div>

                        </div>


                    </div>
                </div>
            </div>
            {/* <!-- End Sidebar Page Container --> */}



        </>


    )

}

export default WordofWisdomeCard;